import { render } from "./Quellen.vue?vue&type=template&id=7ec8bfa2&scoped=true"
import script from "./Quellen.vue?vue&type=script&lang=js"
export * from "./Quellen.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7ec8bfa2"

export default script